<script>
  import options from './ThemeCard.options'
  export default options
</script>

<template>
  <a :href="content.href">
      <article class="kb-group-card-a" :class="content.colorTheme">
          <div class="kb-group-card-a__circle" v-html="content.icon" aria-hidden="true"></div>
          
          <h3 class="kb-group-card-a__title">
            {{ content.title }}
              <span class="kb-group-card-a__title-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 16" role="presentation"><path stroke="#3C3C3C" stroke-linejoin="round" d="m12.167 4 3.623 4-3.623 4"/><path stroke="#3C3C3C" d="M11.746 8H0"/></svg>
              </span>
          </h3>
          <p class="kb-group-card-a__description">{{ content.description }}</p>
          
          <div class="kb-group-card-a__badges">
              <span class="kb-group-card-a__badges-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" role="presentation"><path fill="#3C3C3C" fill-rule="evenodd" d="M4.5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm.5 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1 6.15c0-1.203.91-2.15 2-2.15 1.09 0 2 .947 2 2.15v2.85h.5V9.993A2.496 2.496 0 0 1 13 7.5c1.381 0 2.5 1.117 2.5 2.493V13h-1v.5H16V9.993A2.996 2.996 0 0 0 13 7a3 3 0 0 0-2.898 2.216C9.66 8.488 8.89 8 8 8c-.889 0-1.66.488-2.102 1.216A3 3 0 0 0 3 7C1.344 7 0 8.34 0 9.993V13.5h1.5V13h-1V9.993A2.496 2.496 0 0 1 3 7.5c1.381 0 2.5 1.117 2.5 2.493V13.5H6v-2.85ZM13 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 .5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-3.75-.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z" clip-rule="evenodd"/></svg> 
                  <span v-if="groupsCount !== undefined">
                    {{ groupsCount }} {{ getLabel('groupsLabel') }}
                  </span>
                  <span v-else class="kb-group-card-a__badges-badge__skeleton"></span>
              </span>
          </div>
      </article>
  </a>
</template>
